import React from 'react';
import { useState } from 'react';
import Select from 'react-select'; // Ensure you have react-select installed

const Strengths = () => {
  const exercises = [
    { value: 'Squat', label: 'Squat' },
    { value: 'Bench Press', label: 'Bench Press' },
    { value: 'Deadlift', label: 'Deadlift' },
    { value: 'Overhead Press', label: 'Overhead Press' },
    { value: 'Pull-Up', label: 'Pull-Up' },
    { value: 'Barbell Row', label: 'Barbell Row' },
    { value: 'Snatch', label: 'Snatch' },
    { value: 'Clean and Jerk', label: 'Clean and Jerk' },
    { value: 'Front Squat', label: 'Front Squat' },
    { value: 'Incline Bench Press', label: 'Incline Bench Press' },
    { value: 'Sumo Deadlift', label: 'Sumo Deadlift' },
    { value: 'Romanian Deadlift', label: 'Romanian Deadlift' },
    { value: 'Hip Thrust', label: 'Hip Thrust' },
    { value: 'Dumbbell Bench Press', label: 'Dumbbell Bench Press' },
    { value: 'Dumbbell Row', label: 'Dumbbell Row' },
    { value: 'Dumbbell Shoulder Press', label: 'Dumbbell Shoulder Press' },
    { value: 'Leg Press', label: 'Leg Press' },
    { value: 'Cable Row', label: 'Cable Row' },
    { value: 'Lat Pulldown', label: 'Lat Pulldown' },
    { value: 'Chest Fly', label: 'Chest Fly' },
    { value: 'Tricep Pushdown', label: 'Tricep Pushdown' },
    { value: 'Bicep Curl', label: 'Bicep Curl' },
    { value: 'Lateral Raise', label: 'Lateral Raise' },
    { value: 'Face Pull', label: 'Face Pull' },
    { value: 'Plank', label: 'Plank' },
    { value: 'Russian Twist', label: 'Russian Twist' },
    { value: 'Hanging Leg Raise', label: 'Hanging Leg Raise' },
    { value: 'Farmer’s Carry', label: 'Farmer’s Carry' },
    { value: 'Tire Flip', label: 'Tire Flip' },
  ];

  const [oneRepMaxes, setOneRepMaxes] = useState([{ exercise: null, weight: '', unit: 'lb' }]);

  const handleAddOneRepMax = () => {
    setOneRepMaxes([...oneRepMaxes, { exercise: null, weight: '', unit: 'lb' }]);
  };

  const handleChange = (index, field, value) => {
    const updatedOneRepMaxes = [...oneRepMaxes];
    updatedOneRepMaxes[index][field] = value;
    setOneRepMaxes(updatedOneRepMaxes);
  };

  return (
    <div className="">
      <h1>Strengths</h1>
      <h2>1-Rep Max Metrics</h2>
      <p>Input the equivalent of any one-rep maxes your client has accomplished so we can use that to calculate the progression over the course of the training cycle.</p>
      {oneRepMaxes.map((max, index) => (
        <div key={index} className="one-rep-max">
          <h2>Client Strength Metric #{index + 1}</h2>
          <Select
            options={exercises}
            value={max.exercise}
            onChange={(selectedOption) => handleChange(index, 'exercise', selectedOption)}
            placeholder="Select Exercise"
          />
          <input
            type="number"
            value={max.weight}
            onChange={(e) => handleChange(index, 'weight', e.target.value)}
            placeholder="Weight"
          />
          <select
            value={max.unit}
            onChange={(e) => handleChange(index, 'unit', e.target.value)}
          >
            <option value="lb">lb</option>
            <option value="kg">kg</option>
          </select>
        </div>
      ))}
      <button className="add-another" onClick={handleAddOneRepMax}>
        <span className="icon">+</span> Add Another
      </button>
    </div>
  );
};

export default Strengths;